import {Switch, Route, useLocation, Redirect} from "react-router-dom"
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

import Home from "./pages/Home";
import About from "./pages/About";
import Comics from "./pages/Comics";
import Illustrations from "./pages/Illustrations";
import Contact from "./pages/Contact";
import Landing from "./pages/Landing";
import Layout from "./components/Layout";
import {useEffect} from "react";
import CircleLan from "./pages/Comics/CircleLan/CircleLan";
import ComicsDisplay from "./pages/Comics/ComicsDisplay/ComicsDisplay";

const firebaseConfig = {
  apiKey: "AIzaSyAXKWQLyi9B2pu4WRW2m8t0PyBi2hbd8bY",
  authDomain: "ranvandewereld.firebaseapp.com",
  projectId: "ranvandewereld",
  storageBucket: "ranvandewereld.appspot.com",
  messagingSenderId: "119257432752",
  appId: "1:119257432752:web:c00a53f9e81b7922a87175",
  measurementId: "G-RBBQJMMDMS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
    let location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
        logEvent(analytics, location.pathname)
    }, [location])

    return (
        <Switch>
            <Route path={'/'} exact component={Landing} />
            
            <Redirect from="/:url*(/+)" to={location.pathname.slice(0, -1)} />
            <Layout>
                <>
                    <Route path={'/home'} exact component={Home} />
                    <Route path={'/about'} exact component={About} />
                    <Route path={'/comics'} exact component={Comics} />
                    <Route path={'/comics/circle-lan'} exact component={CircleLan} />
                    <Route path={'/comics/:comic/:section/:chapter'} exact component={ComicsDisplay} />
                    <Route path={'/illustrations'} exact component={Illustrations} />
                    <Route path={'/contact'} exact component={Contact} />
                </>
            </Layout>
        </Switch>


        // <div className="App">
        //     <header className="App-header">
        //         <h1 className="text-6xl font-raleway font-bold">
        //             This is a header 日本語
        //         </h1>
        //         <h1 className="text-6xl font-dancing-script font-bold">
        //             Ran Van de Wereld
        //         </h1>
        //         <h1 className="text-6xl font-m-plus font-bold">
        //             This is a header 日本語
        //         </h1>
        //     </header>
        // </div>
    )
}

export default App
